module.exports = "/**\n * Function to create an optimized svg url\n */\n/**\n * Replace `$search` with `$replace` in `$string`\n * @author Hugo Giraudel\n * @param {String} $string - Initial string\n * @param {String} $search - Substring to replace\n * @param {String} $replace ('') - New value\n * @return {String} - Updated string\n */\nmy-input[name='email'] /deep/ .my-focused .field-icon {\n  color: #3fc5f7; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/personal-details/steps/contact/contact-screen.component.scss
// module id = 1443
// module chunks = 0